var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#youtube_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.51 6.624a3.008 3.008 0 0 0-2.132-2.122C19.505 4 12 4 12 4s-7.507 0-9.376.502A3.005 3.005 0 0 0 .502 6.624C0 8.494 0 12.4 0 12.4s0 3.906.502 5.777A3.005 3.005 0 0 0 2.624 20.3c1.87.494 9.376.494 9.376.494s7.507 0 9.378-.502a3.01 3.01 0 0 0 2.132-2.114c.5-1.87.5-5.777.5-5.777s-.01-3.905-.5-5.776Z",
  fill: "#FB3958"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.6 16 6.237-3.6L9.6 8.8V16Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "youtube_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgYoutube;